/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum DashboardSummaryType {
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly'
}
